import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
export default class PaymentDebtReduces extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create_credit_note: false,
      modal_view_credit_note: false,

      data_sale: [],
      data_customer: [],
      data_bank: [],
      data_product: [],

      tab: "normal",
      type: "",

      uid: params("id") || "",
      sale_uid: "",
      date: "",
      due_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      customer_id: "",
      payment_terms: "",
      address: "",
      withdrawal_type: "",
      phone_number: "",
      payment_type: "",
      tax_number: "",
      receipt_type: "",

      transaction_list: [],
      transaction_list_vat: [],
      credit_note: [],

      is_vat: false,
      discount: 0,
      delivery_cost: 0,

      amount_deposit: 0,
      amount_deposit_need: 0,
      total_pay: 0,

      // เงินสด
      cash_amount: 0,
      // เงินโอน
      transfer_amount: 0,
      transfer_bank_account: "",
      transfer_date: "",
      transfer_time: "",
      // เครดิต
      credit_amount: 0,
      credit_bank_account: "",
      credit_date: "",
      check_number: "",

      amount: 0,
      count_item: 0,
      reason: "",
      status: "",
      remark: "",
      transaction_credit_note: [],
    };
  }

  async componentDidMount() {
    loading(true);
    await this.Get();
    if (params("id")) {
      await this.GetByID(params("id"));
    }

    loading(false);
  }
  Get = async () => {
    let data_customer, data_sale, data_bank, data_product;
    let [result_customer, result_sale, result_bank, result_product] =
      await Promise.all([
        GET("admin/setting/customers/list", { page: 0, data_search: "" }),
        GET("admin/invoices/list", {
          page: 0,
          status_code: "",
        }),
        GET("admin/setting/banks/list", { page: 0, data_search: "" }),
        GET("admin/setting/spare-parts/list", { page: 0, data_search: "" }),
      ]);
    if (result_customer?.status) {
      
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
      }));
    }
    if (result_sale?.status) {
      data_sale = result_sale.data
        .filter((e) => ["รอชำระ", "ใบวางบิล"].includes(e.status))
        .map((e) => ({
          value: e.uid,
          label: e.document_no,
        }));
    }
    if (result_bank?.status) {
      data_bank = result_bank.data.map((e) => ({
        value: e.uid,
        label: `${e.bank_name} : ${e.account_number} (${e.account_name})`,
      }));
    }
    if (result_product?.status) {
      data_product = result_product.data.map((e) => ({
        value: e.uid,
        label: `${e.product_code} ${e.product_name}`,
        id: e.id,
        warehouse_id: e.warehouse?.uid || "",
        unit_name: e.unit_name,
        is_serial_number: e.is_serial_number,
        product_code: e.product_code,
        product_name: e.product_name,
        sale_price: e.sale_price,
      }));
    }
    this.setState({
      data_customer,
      data_sale,
      data_bank,
      data_product,
    });
  };
  GetByID = async (id) => {
    const { data_product } = this.state;
    loading(true);
    let result = await GET("admin/invoices/list", { uid: id });
    
    let item = result.data;
    if(item.sale){
    this.setState({
      ...item,
      uid: item.uid,
      sale_uid: item.sale?.uid || "",
      date: item.created_at ? item.created_at.split("T")[0] : "",
      due_date: item.sale?.due_date
        ? item.sale?.due_date
        : item.sale?.payment_type === "ชำระเงินเชื่อ"
        ? format_date(
            new Date(
              new Date(item.created_at).setMonth(
                new Date(item.created_at).getMonth() + 1
              )
            ),
            "yyyy-mm-25",
            "en"
          )
        : format_date(new Date(), "yyyy-mm-dd", "en"),
      // customer
      customer_id: item.sale?.customer.uid,
      payment_terms: item.sale?.customer.payment_conditions,
      address: item.sale?.customer.address,
      phone_number: item.sale?.customer.phone,
      tax_number: item.sale?.customer.tax_number,

      withdrawal_type: item.sale?.withdrawal_type,
      payment_type: item.sale?.payment_type,
      receipt_type: item.sale?.receipt_type,

      transaction_list: item.sale?.transaction_list,
      transaction_list_vat: item.sale?.transaction_list_vat?.map((e) => ({
        ...e,
        product_id:
          data_product.find((p) => p.product_code === e.product_code)?.value ||
          "",
      })),
      credit_note: item.credit_note || [],
      is_vat: item.sale?.is_vat,
      discount: item.sale?.discount,

      amount_deposit: Number(item.sale?.amount_deposit),
      total_pay: Number(item.sale?.total_pay),
      type: "sale",
    });
  }else if(item.repair){

    this.setState({
      ...item,
      uid: item.uid,
      sale_uid: item.repair?.uid || "",
      date: item.created_at ? item.created_at.split("T")[0] : "",
      due_date: item.repair?.due_date
        ? item.repair?.due_date
        : item.repair?.payment_type === "ชำระเงินเชื่อ"
        ? format_date(
            new Date(
              new Date(item.created_at).setMonth(
                new Date(item.created_at).getMonth() + 1
              )
            ),
            "yyyy-mm-25",
            "en"
          )
        : format_date(new Date(), "yyyy-mm-dd", "en"),
      // customer
      customer_id: item.repair?.customer.uid,
      payment_terms: item.repair?.customer.payment_conditions,
      address: item.repair?.customer.address,
      phone_number: item.repair?.customer.phone,
      tax_number: item.repair?.customer.tax_number,

      withdrawal_type: item.repair?.withdrawal_type,
      payment_type: item.repair?.payment_type,
      receipt_type: item.repair?.receipt_type,

      transaction_list: item.repair?.transaction_list,
      transaction_list_vat: item.repair?.transaction_list_vat?.map((e) => ({
        ...e,
        product_id:
          data_product.find((p) => p.product_code === e.product_code)?.value ||
          "",
      })),
      credit_note: item.credit_note || [],
      is_vat: item.repair?.is_vat,
      discount: item.repair?.discount,

      amount_deposit: Number(item.repair?.amount_deposit),
      total_pay: Number(item.repair?.total_pay),
      type: "repair",
    });
  }

    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, sale_uid, is_vat, type } = this.state;

    loading(true);
    let body = {
      is_vat,
    };

    let result = await PUT(type === "sale" ? "admin/sales/update/" + sale_uid : "admin/repairs/update/" + sale_uid, body);
    if (result?.status) {
      alert("", "success");
      this.GetByID(uid);
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  CreateUpdateCreditNote = async () => {
    const {
      uid,
      amount,
      count_item,
      reason,
      status,
      remark,
      transaction_credit_note,
      data_product,
    } = this.state;
    if (!transaction_credit_note.some((e) => e.checked)) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกอย่างน้อย 1 รายการ");
      return;
    }
    if (!reason) {
      alert("", "warning", "แจ้งเตือน", "กรุณาาระบุเหตุผลการลดหนี้");
      return;
    }
    let _total = 0;
    for (let item of transaction_credit_note) {
      _total += (Number(item.credit_unit_price) * Number(item.credit_qty));
    }
    loading(true);
    let body = {
      invoice_id: uid,
      amount: _total,
      count_item: transaction_credit_note.filter((e) => e.checked).length,
      reason,
      status: "",
      remark: reason,
      transaction_credit_note: transaction_credit_note.map((e) => ({
        ...e,
        serial_number: e.serial_number?.split(",").map(s=>s.trim()) || [],
        type: "ลดหนี้",
        qty: Number(e.credit_qty),
        unit_price: Number(e.credit_unit_price),
        amount: Number(e.credit_unit_price),
        product_id:
          data_product.find((p) => p.product_code === e.product_code)?.value ||
          "",
      })),
    };
    let result = await POST("admin/credit-notes/create", body);
    if (result?.status) {
      this.setState({ modal_create_credit_note: false });
      alert("", "success");
      this.GetByID(uid);
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  render() {
    const {
      modal_create_credit_note,
      modal_view_credit_note,

      data_sale,
      data_customer,
      data_bank,
      data_product,

      tab,

      uid,
      sale_uid,
      date,
      due_date,
      customer_id,
      payment_terms,
      address,
      withdrawal_type,
      phone_number,
      payment_type,
      tax_number,
      receipt_type,

      transaction_list,
      transaction_list_vat,
      credit_note,
      is_vat,
      discount,

      amount_deposit,
      amount_deposit_need,
      total_pay,

      cash_amount,
      transfer_amount,

      transfer_bank_account,
      transfer_date,
      transfer_time,

      credit_amount,
      credit_bank_account,
      credit_date,
      check_number,

      amount,
      count_item,
      reason,
      status,
      remark,
      transaction_credit_note,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="d-flex justify-content-between mb-2">
            <h4 className="fw-bold mb-3 me-3">ใบลดหนี้</h4>
          </div>
          {/* รายการสินค้า */}
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="row mb-3">
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เลขรายการใบแจ้งหนี้</div>
                <Select
                  className="form-control"
                  placeholder="เลขรายการใบแจ้งหนี้..."
                  options={data_sale}
                  onChange={(e) => {
                    this.setState({ uid: e });
                    if (e) this.GetByID(e);
                  }}
                  value={uid}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ชื่อลูกค้า</div>
                <Select
                  options={data_customer}
                  className="form-control"
                  placeholder="ชื่อลูกค้า..."
                  onChange={(e) => {
                    this.setState({ customer_id: e.target.value });
                  }}
                  value={customer_id}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ที่อยู่</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ที่อยู่..."
                  onChange={(e) => {
                    this.setState({ address: e.target.value });
                  }}
                  value={address}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เบอร์โทรศัพท์</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เบอร์โทรศัพท์..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ phone_number: e.target.value });
                  }}
                  value={phone_number}
                  maxLength={10}
                  disabled
                />
              </div>
            </div>
          </div>
          {/* ใบลดหนี้ */}
          <div className="rounded-4 bg-white p-3 mb-3">
            <h5 className="fw-bold mb-3 me-3">ใบลดหนี้</h5>
            <div>
              <div className="table-responsive">
                <table className="table rounded-3 overflow-hidden table-hover">
                  <thead>
                    <tr>
                      <td className="text-nowrap">เลขที่ใบลดหนี้</td>
                      <td className="text-nowrap">วันที่ออกใบลดหนี้</td>
                      <td className="text-nowrap">เหตุผลการลดหนี้</td>
                      <td className="text-nowrap text-end">จำนวนเงินที่ลดหนี้</td>
                      <td className="text-nowrap"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {credit_note?.map((item, index) => (
                      <tr>
                        <td className="text-nowrap">{item.document_no}</td>
                        <td className="text-nowrap">
                          {item.created_at ? format_date(item.created_at) : ""}
                        </td>
                        <td className="text-nowrap">{item.reason || ""}</td>
                        <td className="text-nowrap text-end">{toFixed(item.amount)}</td>

                        <td className="text-center align-middle wpx-100">
                          <div className="d-flex">
                            <BtnIcon
                              type="view"
                              onClick={() => {
                                this.setState({
                                  transaction_credit_note:
                                    item.transaction_credit_note,
                                  reason: item.reason,
                                  modal_view_credit_note: true,
                                });
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.setState({
                      amount: 0,
                      count_item: 0,
                      reason: "",
                      status: "",
                      remark: "",
                      transaction_credit_note: transaction_list.map((e) => ({
                        ...e,
                        serial_number: "",
                        credit_qty: 0,
                        credit_unit_price: 0,
                      })),
                      modal_create_credit_note: true,
                    });
                  }}
                >
                  เพิ่มรายการ
                </button>
              </div>
              <div className="rounded-4 bg-white p-3">
                <div className="row">
                  <div className="col-12 col-md-6 mb-2"></div>
                  <div className="col-12 col-md-6 mb-2">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>มูลค่าเดิม</b>
                      <span>
                        {(() => {
                          let total = 0;
                          transaction_list.forEach((item) => {
                            total +=
                              Number(item.qty) *
                              (Number(item.unit_price) - Number(item.discount));
                          });
                          if (isNaN(total)) total = 0;
                          return `${toFixed(total || 0)} บาท`;
                        })()}
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>มูลค่าที่ถูกต้อง</b>
                      <span>
                        {(() => {
                          let _total = 0;
                          transaction_list.forEach((item) => {
                            _total +=
                              Number(item.qty) *
                              (Number(item.unit_price) - Number(item.discount));
                          });
                          if (isNaN(_total)) _total = 0;
                          return `${toFixed(
                            _total - total(credit_note, "amount") || 0
                          )} บาท`;
                        })()}
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>ผลต่าง</b>
                      <span>{toFixed(total(credit_note, "amount"))} บาท</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex">
                        <b>ภาษีมูลค่าเพิ่ม 7%</b>
                        {/* <Switch
                          className="ms-3"
                          onChange={(e) => {
                            this.setState({ is_vat: e },()=>this.CreateUpdate());
                            
                          }}
                          checked={is_vat}
                        /> */}
                      </div>
                      <span>
                        {(() => {
                          const vatRate = is_vat ? 0.07 : 0;
                          let _total = 0;
                          transaction_list.forEach((item) => {
                            _total +=
                              Number(item.qty) *
                              (Number(item.unit_price) - Number(item.discount));
                          });
                          if (isNaN(_total)) _total = 0;

                          const vat = _total * vatRate;

                          return `${toFixed(vat)} บาท`;
                        })()}
                      </span>
                    </div>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>รวม</b>
                      <h4 className="fw-bold text-success">
                        {(() => {
                          const vatRate = is_vat ? 0.07 : 0;
                          let _total = 0;
                          transaction_list.forEach((item) => {
                            _total +=
                              Number(item.qty) *
                              (Number(item.unit_price) - Number(item.discount));
                          });
                          if (isNaN(_total)) _total = 0;
                          const vat = _total * vatRate;
                          return `${toFixed(
                            _total - total(credit_note, "amount") + vat || 0
                          )} บาท`;
                        })()}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create_credit_note}
          onHide={() => this.setState({ modal_create_credit_note: false })}
          fullscreen={true}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">เพิ่มใบลดหนี้</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td>
                      {" "}
                      <input
                        type="checkbox"
                        checked={transaction_credit_note.every(
                          (e) => e.checked
                        )}
                        onChange={(e) => {
                          this.setState({
                            transaction_credit_note:
                              transaction_credit_note.map((t) => ({
                                ...t,
                                checked: e.target.checked,
                              })),
                          });
                        }}
                      />
                    </td>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap">SerialNo</td>
                    <td className="text-nowrap text-center">จำนวน</td>
                    <td className="text-nowrap text-center">ราคา/หน่วย</td>
                    <td className="text-nowrap text-center">จำนวนที่ลดหนี้</td>
                    <td className="text-nowrap text-center">
                      ราคา/หน่วยที่ลดหนี้
                    </td>
                    <td className="text-nowrap text-end">มูลค่ารวม</td>
                  </tr>
                </thead>
                <tbody>
                  {transaction_credit_note?.map((item, index) => (
                    <tr>
                      <td>
                        {" "}
                        <input
                          type="checkbox"
                          checked={item.checked}
                          onChange={(e) => {
                            transaction_credit_note[index].checked =
                              e.target.checked;
                            transaction_credit_note[index].credit_qty = 0;
                            transaction_credit_note[index].credit_unit_price = e
                              .target.checked
                              ? item.unit_price
                              : 0;
                            this.setState({
                              transaction_credit_note: transaction_credit_note,
                            });
                          }}
                        />
                      </td>
                      <td className="text-nowrap">{item.product_code} {item.product_name}</td>
                      <td className="text-nowrap">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            transaction_credit_note[index].serial_number =
                              e.target.value;
                            this.setState({ transaction_credit_note });
                          }}
                          value={item.serial_number}
                          disabled={item.credit_qty === 0}
                        />
                      </td>
                      <td className="text-nowrap">{item.qty}</td>
                      <td className="text-nowrap">
                        {toFixed(item.unit_price)}
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex">
                          <button
                            className="btn btn-primary wpx-30"
                            disabled={!item.checked}
                            onClick={async () => {
                              if (item.credit_qty <= 1) {
                                transaction_credit_note[index].credit_qty = 0;
                                transaction_credit_note[index].serial_number = "";
                                this.setState({
                                  transaction_credit_note:
                                    transaction_credit_note,
                                });
                              } else {
                                transaction_credit_note[index].credit_qty =
                                  Math.max(0, item.credit_qty - 1);
                                this.setState({ transaction_credit_note });
                              }
                            }}
                          >
                            -
                          </button>
                          <input
                            type="text"
                            className="form-control wpx-60 mx-1 text-center"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_credit_note[index].credit_qty =
                                Number(e.target.value);
                                if(Number(e.target.value) === 0){

                                transaction_credit_note[index].serial_number = "";
                                }
                              this.setState({ transaction_credit_note });
                            }}
                            value={item.credit_qty}
                            disabled={!item.checked}
                          />
                          <button
                            className="btn btn-primary wpx-30"
                            disabled={!item.checked}
                            onClick={() => {
                              if (item.credit_qty >= item.qty) {
                                return;
                              }
                              transaction_credit_note[index].credit_qty =
                                Math.max(0, item.credit_qty + 1);
                              this.setState({ transaction_credit_note });
                            }}
                          >
                            +
                          </button>
                        </div>
                      </td>
                      <td className="text-nowrap">
                        <input
                          type="text"
                          className="form-control wpx-100 mx-1 text-end"
                          onChange={(e) => {
                            if (!float(e.target.value)) return;
                            if (
                              Number(item.unit_price) < Number(e.target.value)
                            ) {
                              e.target.value = Number(item.unit_price);
                            }
                            transaction_credit_note[index].credit_unit_price =
                              e.target.value;
                            this.setState({ transaction_credit_note });
                          }}
                          value={item.credit_unit_price}
                          disabled={!item.checked}
                        />
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(Number(item.credit_unit_price) * Number(item.credit_qty)) || "0.00"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end">
              <div className="d-flex mb-3">
                <b className="wpx-100">มูลค่าค้างชำระ</b>
                <h4 className="fw-bold text-success">
                  {(() => {
                    let _total = 0;
                    transaction_credit_note.forEach((item) => {
                      const creditUnitPrice = Number(
                        item.credit_unit_price ?? 0
                      ) * item.credit_qty;
                      const unitPrice = Number(item.unit_price ?? 0) * item.qty;
                      _total += unitPrice - creditUnitPrice;
                    });
                    return toFixed(_total);
                  })()}
                </h4>
              </div>
            </div>
            <hr />
            <div className="mb-3">เหตุผลการลดหนี้</div>
            <textarea
              className="form-control mb-3"
              rows={5}
              onChange={(e) => {
                this.setState({ reason: e.target.value });
              }}
              value={reason}
            />
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  if(transaction_credit_note.filter(e=>e.checked && Number(e.credit_unit_price) === 0).length > 0){
                                                       alert("","warning","แจ้งเตือน","กรุณากรอกราคา/หน่วยที่ลดหนี้ให้ครบ");
                                                       return;
                                                     }
                  this.CreateUpdateCreditNote();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create_credit_note: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal
          show={modal_view_credit_note}
          onHide={() => this.setState({ modal_view_credit_note: false })}
          size="lg"
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">รายการใบลดหนี้</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap text-center">จำนวนที่ลดหนี้</td>
                    <td className="text-nowrap text-end">
                      ราคา/หน่วยที่ลดหนี้
                    </td>
                    <td className="text-nowrap text-end">มูลค่ารวม</td>
                  </tr>
                </thead>
                <tbody>
                  {transaction_credit_note?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{item.product_name}</td>
                      <td className="text-nowrap text-center">{item.qty || ""}</td>
                      <td className="text-nowrap text-end">{toFixed(item.unit_price)}</td>
                      <td className="text-nowrap text-end">
                        {toFixed(Number(item.qty) * Number(item.unit_price)) ||
                          "0.00"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end">
              <div className="d-flex mb-3">
                <b className="wpx-100">มูลค่าค้างชำระ</b>
                <h4 className="fw-bold text-success">
                  {(() => {
                    let _total = 0;
                    transaction_credit_note.forEach((item) => {
                      const qty = Number(item.qty ?? 0);
                      const unitPrice = Number(item.unit_price ?? 0);
                      _total += qty * unitPrice;
                    });
                    return toFixed(_total);
                  })()}
                </h4>
              </div>
            </div>
            <hr />
            <div className="mb-3">เหตุผลการลดหนี้</div>
            <p>{reason}</p>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
